import { CONSTANTS__environment_client } from '@/constants/CONSTANTS__environment_client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { REMOTE__user_auth_login_with_email_and_password } from '@/state/user/auth/login/REMOTE__user_auth_login_with_email_and_password';
import { DTO__user_credentials } from '@shared/dto/+user/auth/DTO__user_credentials';

export function WATCHER__auto_login() {
  const dispatch = use_dispatch();

  const { VITE_AUTH_AUTOLOGIN_BOOLEAN, VITE_AUTH_TEST_USER_EMAIL, VITE_AUTH_TEST_USER_PASSWORD } = CONSTANTS__environment_client;

  /*
   * EFFECTS
   */
  use_effect(() => {
    void try_login();
  });

  /*
   * METHODS
   */

  async function try_login() {
    if (!VITE_AUTH_AUTOLOGIN_BOOLEAN) return;

    const credentials = new DTO__user_credentials(VITE_AUTH_TEST_USER_EMAIL, VITE_AUTH_TEST_USER_PASSWORD);

    await dispatch(REMOTE__user_auth_login_with_email_and_password({ credentials }));
  }

  return <></>;
}
